<script>
  import { flip } from "svelte/animate";
  import { fly } from "svelte/transition";
  import { notifications } from "../utils/notifications.js";

  export let themes = {
    danger: "border-red-800",
    success: "border-green-800",
    warning: "border-yellow-800",
    info: "border-blue-800",
    default: "border-gray-300",
  };
</script>

<div
  class="fixed top-0 right-0 z-20 flex flex-col items-center mt-20 mr-5 text-white font-semibold"
>
  {#each $notifications as notification (notification.id)}
    <div
      animate:flip
      class="rounded-lg border-l-8  bg-gray-800 mb-2 {themes[
        notification.type
      ]} px-4 py-2"
      transition:fly={{ x: 20 }}
    >
      <div class="p-1">{notification.message}</div>
      {#if notification.icon}<i class={notification.icon} />{/if}
    </div>
  {/each}
</div>
